module.exports = __webpack_public_path__ + "static/media/product1.e46e6524.jpg";